import React, { CSSProperties } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

interface EditButtonProps {
    color: string;
    onClick?: () => void;
    iconOnly?: boolean;
    text?: string;
}

const EditButton: React.FC<EditButtonProps> = ({ color, onClick, iconOnly = false, text = 'Upraviť' }) => (
    <button
        type="button"
        onClick={onClick}
        className={`st-btn st-btn--fill${iconOnly ? ' st-btn--icon' : ''}`}
        style={{ '--btn-accent': color } as CSSProperties}
    >
        <FontAwesomeIcon icon={faEdit} />
        {!iconOnly && <span>{text}</span>}
    </button>
);

export default EditButton;
